import { render, staticRenderFns } from "./myExpress.vue?vue&type=template&id=a8989488&scoped=true&"
import script from "./myExpress.vue?vue&type=script&lang=js&"
export * from "./myExpress.vue?vue&type=script&lang=js&"
import style0 from "./myExpress.vue?vue&type=style&index=0&id=a8989488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8989488",
  null
  
)

export default component.exports